<script setup lang="ts">
const documentId = inject("documentId") as any;
const thesaurusStore = useDocumentThesaurusStore(documentId);
const { pages, documentText } = storeToRefs(thesaurusStore);
</script>

<template>
  <div class="flex flex-row flex-wrap gap-2 px-4 pt-4 pb-2" v-auto-animate>
    <span
      v-for="(page, index) in pages"
      :key="page.key"
      class="flex flex-row items-center gap-2"
    >
      <div class="inline-flex items-center">
        <!-- <DocumentEditorReviewPanelThesaurusReplaceButton
          v-if="
            index > 0 &&
            documentText != undefined &&
            page.label != documentText.text
          "
          :text="page.label"
        /> -->
        <span
          :class="{
            'font-bold text-secondary': index == pages.length - 1,
            'cursor-pointer hover:bg-light-default rounded px-1 py-[2px] transition-colors':
              index != pages.length - 1,
          }"
          @click="thesaurusStore.onPopToPage(index)"
        >
          {{ page.label }}
        </span>
      </div>
      <span v-if="index != pages.length - 1">
        <BaseIconChevronRight />
      </span>
    </span>
  </div>
</template>

<style scoped></style>
